import React from 'react';

import { styled } from '@material-ui/core/styles';
import quickstartImage from '../../assets/quickstart_rocket.svg';

import docsImage from '../../assets/docs.png';
import './QuickStart.scss';

import Card from '../Card/Card';

type PropsType = {
  onQuickStart: () => void;
  onDocsClick: () => void;
};

const QuickStartRow = styled('div')(({ theme }) => ({
  marginTop: '32px',
  display: 'grid',
  gridGap: '32px',

  gridTemplateColumns: '280px 280px',

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '628px 298px',
  },
}));

const QuickStart: React.FC<PropsType> = ({ onQuickStart, onDocsClick }) => (
  <QuickStartRow>
    <Card
      title="Quick start your project"
      buttonText="Start Here"
      imgSrc={quickstartImage}
      imgAlt="Quick Start logo"
      onClick={onQuickStart}
      special
    />
    <Card
      title="Docs"
      buttonText="View Docs"
      imgSrc={docsImage}
      imgAlt="Docs logo"
      description="View all our help docs in one place"
      onClick={onDocsClick}
      thin
    />
  </QuickStartRow>
);

export default QuickStart;
